import { render, staticRenderFns } from "./msMessageToastV2.vue?vue&type=template&id=0090c12a&scoped=true"
import script from "./msMessageToastV2.vue?vue&type=script&lang=js"
export * from "./msMessageToastV2.vue?vue&type=script&lang=js"
import style0 from "./msMessageToastV2.vue?vue&type=style&index=0&id=0090c12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0090c12a",
  null
  
)

export default component.exports